<template>
  <div v-if="contents.length > 0" class="live live02">
    <div class="inner">
      <Title>
        <template #title>
          リトル・ママチャンネル
        </template>
      </Title>
      <div class="description">
        <p>
          オンラインで楽しめるハイハイレースなど、視聴者参加型のコンテンツが盛りだくさん！イベントの最後には豪華抽選会の当選発表も★
        </p>
      </div>
      <div class="live-programs">
        <LiveProgram10kantou
          v-for="(program, key) in contents"
          :key="program.id + key + 'provider'"
          :program="program"
          liveType="provider"
          :month="month"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/atoms/Title.vue'
import LiveProgram10kantou from '@/components/molecules/202010kantou/LiveProgram.vue'
export default {
  props: {
    month: {
      type: String,
      required: true
    },
    contents: {}
  },
  components: {
    Title,
    LiveProgram10kantou
  }
}
</script>

<style lang="sass" scoped>
.live02
  padding: 25px 0
</style>
